export default "__VITE_ASSET__WKCCR5eR__"